import {Component, computed, effect, input, InputSignal, model, OnInit, output, Signal, signal} from '@angular/core';
import { NgClass } from '@angular/common';
import {TranslatePipe} from "@ngx-translate/core";

export interface Button {
  label: string;
  value: any;
}

@Component({
  selector: 'app-button-group',
  imports: [NgClass, TranslatePipe],
  templateUrl: './button-group.component.html',
  styleUrls: ['./button-group.component.scss']
})
export class ButtonGroupComponent implements OnInit {

  options = input.required<string[]>();

  /** Alkuperäinen arvo */
  initialValue = input<string>(null);
  /** LinkedValue, jota voidaan käyttää oletusarvona ja myöhempänä kaksisuuntaisena sitoutumisena */
  linkedValue = model<string>(null);

  protected selectedValue = signal<string | null>(null);

  selected_output = output<string | null>();

  disabled = input<boolean>(false);

  translated: InputSignal<boolean> = input<boolean>(false);

  constructor() {
    // Jos linkedValue muuttuu, priorisoidaan se valituksi
    effect(() => {
      const lv = this.linkedValue();
      if (lv !== null && lv !== undefined) {
        this.selectedValue.set(lv);
      }
    });
  }

  ngOnInit() {
    // Jos linkedValue on annettu, käytetään sitä oletusarvona,
    // muuten asetetaan initialValue, mikäli se on määritelty
    if (this.linkedValue() !== null) {
      this.selectedValue.set(this.linkedValue());
    } else if (this.initialValue() !== null) {
      this.selectedValue.set(this.initialValue());
    }
  }

  onButtonClick(option: string) {
    if(this.disabled()) return;
    this.selectedValue.set(option);
    this.selected_output.emit(this.selectedValue());
  }
}
